// Generated sandbox code: SSVMN - PlusTools - Editor v6.5.0 - 22/02/2022
// Created/Updated by amorales - 20/11/2023

import { Component} from '@angular/core'
import { BaseController } from './base.controller';
import { Action, ApiResponseModel, AuthService, CtButtonComponent, CtFormComponent, CtInputTextComponent, CtMessageComponent, CtMessageContainerComponent, CtSelectComponent, EntityField, HttpService } from 'components';
import { Router } from '@angular/router';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';


@Component({
	selector: 'sg-vi05',
	template: `<div [id]="getId()" #target><div>`
})

export class SgVi05 extends BaseController{
	
	private docIdentificacion : string;
	private currentPassword : string;
	private newPassword : string;
	private confirmPassword : string;
	private tipIdentificacion : string;
	private messageContainer : CtMessageContainerComponent;


  constructor(private authService: AuthService, private router: Router) {
		super();
		this.setViewCode('SG_VI05');
	  }

	/* ---------------------- CONTROLLER LOGIC ------------------- */

	public setUserData(action: Action): void {
		
		const inputDocIdentificacion: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[0]);
		const inputTipIdentificacion: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[1]);

		this.storeService.setState('docIdPatrono',  this.authService.loggedUser.user.user_code);
	
		this.storeService.getStateObservable('docIdPatrono').subscribe({
		  next: (value) => {
			this.docIdentificacion = value;
			inputDocIdentificacion.setValue(this.docIdentificacion);
			this.setADN(this.docIdentificacion,inputTipIdentificacion);
		},
	
		  error: (error: any) => {
		  }
		})
	  }


	
	  public setADN(docIdentificacion: string, inputTipIdentificacion: CtInputTextComponent) {


		let contRequest = {
		  "Type": 1,
		  "UserCode": "SVA",
		  "Source": "SVA",
		  "Conditions":
		  {
			"Data": [{
			  "Name": "DOC_IDENTIFICACION",
			  "Alias": "DOC_IDENTIFICACION",
			  "Value": docIdentificacion,
			  "Display": "",
			  "Type": 1,
			  "FamilyId": ""
			},
			]
		  },
		  "Data": [],
		  "Files": []
		}
	
		if (docIdentificacion) {
	
		  this.httpService.post(HttpService.ENDPOINT + '/api/process/CLIENTE_CL/SER_RET_TIP_IDENTIFICACION', contRequest).subscribe({
			next: (response: ApiResponseModel) => {
				response['Data'][0]['ArrayEntities']['List'].forEach((entity: EntityField) => {
					if (entity.Name === 'TIP_IDENTIFICACION')
					  return inputTipIdentificacion.setValue(entity.Value);
				  });
			},
			error: (error: any) => {
				inputTipIdentificacion = error;
				;
			}
		  });
		}

	
	  }
	  
	  public changePassword(action: Action) :void {

		const inputDocIdentificacion: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[0]);
		const inputCurrentPassword: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[1]);
		const inputNewPassword: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[2]);
		const inputConfirmPassword: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[3]);

		this.docIdentificacion = inputDocIdentificacion.getValue();
		this.currentPassword = inputCurrentPassword.getValue();
		this.newPassword = inputNewPassword.getValue();
		this.confirmPassword = inputConfirmPassword.getValue();

		this.validatePassword(this.docIdentificacion,this.currentPassword,this.newPassword, this.confirmPassword)
	  }


	  public validatePassword(docIdentificacion: string, currentPassword: string, newPassword : string, confirmPassword : string) {
		let contRequest = {
			"Type": 1,
			"UserCode": "SVA",
			"Source": "SVA",
			"Conditions":
			{
			  "Data": [
				{
				  "Name": "DOC_IDENTIFICACION",
				  "Alias": "DOC_IDENTIFICACION",
				  "Value": docIdentificacion
	  
				},
				{
				  "Name": "CURRENT_PASSWORD",
				  "Alias": "CURRENT_PASSWORD",
				  "Value": currentPassword
				}
	  
			  ]
			},
			"Data": []
		  }
	
		if (docIdentificacion) {
	
		  this.httpService.post(HttpService.ENDPOINT + '/api/process/USER/SER_VALIDATE_CURR_PASS_SVA', contRequest).subscribe({
			next: (response: ApiResponseModel) => {
				
				this.setAdnPassword(docIdentificacion,newPassword,confirmPassword);	
	
			},
			error: (error: any) => {
				this.messageContainer.setValue(error);
			}
		  });
		}
	  }

	  public setAdnPassword(docIdentificacion : string ,newPassword : string,confirmPassword : string) {


		let contRequest = {
		  "Type": 1,
		  "UserCode": "SVA",
		  "Source": "SVA",
		  "Conditions":
		  {
			"Data": [{
			  "Name": "USER_IDENTIFIER",
			  "Alias": "USER_IDENTIFIER",
			  "Value": docIdentificacion,
			  "Display": "",
			  "Type": 1,
			  "FamilyId": ""
			},
			{
				"Name": "PASSWORD",
				"Alias": "PASSWORD",
				"Value": newPassword,
				"Display": "",
				"Type": 1,
				"FamilyId": ""
			},
			{
				"Name": "CONFIRM_PASSWORD",
				"Alias": "CONFIRM_PASSWORD",
				"Value": confirmPassword,
				"Display": "",
				"Type": 1,
				"FamilyId": ""
			},
			{
				"Name": "AUTH_CODE",
				"Alias": "AUTH_CODE",
				"Value": "",
				"Display": "",
				"Type": 1,
				"FamilyId": ""
			}
			
			]
		  },
		  "Data": [],
		  "Files": []
		}
	
		if (docIdentificacion) {
	
		  this.httpService.post(HttpService.ENDPOINT + '/api/process/USER/SER_SET_NEW_PASSWORD_NO_AUTH', contRequest).subscribe({
			next: (response: ApiResponseModel) => {
				this.plusAlertService.setCtDialogInfo('Operación finalizada con éxito', 'success',
				'success', 'primary', 'Se han guardado los cambios',
				true, 'Finalizar', 'Cancelar');
			},
			error: (error: any) => {
				this.plusAlertService.setCtDialogInfo('Error al cambiar la contraseña', 'error',
				'error', 'primary', 'No se pudieron guardar los cambios',
				true, 'Finalizar', 'Cancelar');
			}
		  });
		}
	
	
	  }

	/* -------------------- END CONTROLLER LOGIC ----------------- */

}
